export const RoomViewEnum = {
    FIRST : 1,
    SECOND : 2,
    THIRD : 3,
    FOURTH : 4
}